import type {ThemeConfig} from 'antd';

export const colors = {
  primary: '#0a7e8c',
  primaryLight: '#e6f4f6',
  primaryDark: '#065f6a',
  navbar: '#d6e8eb',
  navbarBorder: '#b8d4d9',
  footer: '#f5f7f8',
  footerText: '#8c9ba5',
  background: '#f5f7fa',
  surface: '#ffffff',
  textPrimary: '#1a2b3c',
  textSecondary: '#5a6b7c',
  border: '#e2e8f0',
  borderDark: '#c4cdd5',
  danger: '#e74c3c',
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

export const theme: ThemeConfig = {
  token: {
    colorPrimary: colors.primary,
    colorBgContainer: colors.surface,
    colorText: colors.textPrimary,
    colorTextSecondary: colors.textSecondary,
    colorBorder: colors.border,
    borderRadius: 6,
    fontFamily: "'Roboto Condensed', sans-serif",
  },
  components: {
    Layout: {
      headerBg: colors.navbar,
      footerBg: colors.footer,
      bodyBg: colors.background,
      footerPadding: '2px 24px',
    },
    Menu: {
      fontSize: 15,
      horizontalItemSelectedColor: colors.primary,
      horizontalItemSelectedBg: 'rgba(10, 126, 140, 0.12)',
      horizontalItemHoverColor: colors.primaryDark,
      horizontalItemBorderRadius: 6,
      itemBg: 'transparent',
    },
    Table: {
      cellPaddingBlock: 8,
      cellPaddingInline: 8,
    },
    Card: {
      borderRadiusLG: 10,
    },
    Button: {
      borderRadius: 6,
    },
  },
};
